import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { BreedinPlants } from '../../components/economicsphere/ui/breedingplants';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const BreedinPlantsPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Племенные заводы</title>
            </Helmet>
            <BreedinPlants/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default BreedinPlantsPage
